import React, { useEffect } from 'react';
import { useInfiniteQuery } from 'react-query';
import { useParams } from 'react-router';

import { Box, Grid } from '@material-ui/core';

import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import { FLEET_SELF_INSPECTIONS } from '../../../constants/selfInspections.constant';
import { useSelfInspectionDataContext } from '../../../context/SelfInspection/selfInspection.provider';
import { useSidebarContext } from '../../../context/sidebar/sidebar.provider';
import {
  SELF_INSPECTIONS_QUERY,
  selfInspectionsQuery,
} from '../../../query/selfInspections/selfInspections';
import ChooseInspection from './Steps/ChoosePolicy.component';
import SelfInspectionSummary from './Steps/SelfInspectionSummary.component';
import VehiclePart from './Steps/VehiclePart.component';

const SelfInspectionWrapped = () => {
  const {
    loading,
    step,
    goBack,
    selectedInspection,
    setSelectedInspection,
    steps,
    setSteps,
    reset,
  } = useSelfInspectionDataContext();

  const { data: selfInspections2 } = useInfiniteQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    { getNextPageParam: (lastPage) => {} }
  );

  const { id }: any = useParams();
  const { setStepperTitle, setStep } = useSidebarContext();

  useEffect(() => {
    if (
      !(
        selfInspections2 &&
        selfInspections2?.pages?.flat().length >= FLEET_SELF_INSPECTIONS
      )
    ) {
      const selected =
        (selfInspections2 &&
          selfInspections2?.pages
            ?.flat()
            .find((inspection: any) => inspection.id === Number(id))) ||
        null;

      if (selected) {
        setSelectedInspection(selected);
        const { vehicle } = selected;
        const { parts } = vehicle;

        setSteps((currSteps: any) => {
          const newSteps = currSteps;

          parts.forEach((part: any) => {
            if (
              newSteps.findIndex((step: any) => step?.part?.id === part.id) ===
              -1
            ) {
              newSteps.push({
                title: 'Fotografías',
                content: <VehiclePart vehicle={vehicle} vehiclePart={part} />,
                part,
              });
            }
          });

          if (
            newSteps.findIndex((step: any) => step.title === 'Resumen') === -1
          ) {
            newSteps.push({
              title: 'Resumen',
              content: <SelfInspectionSummary />,
            });
          }

          return newSteps;
        });
      }
    } else {
      setSteps((currSteps: any) => {
        const newSteps = currSteps;

        newSteps.unshift({
          title: 'Flota',
          content: <ChooseInspection />,
        });

        return newSteps;
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, selfInspections2, setSelectedInspection, setSteps]);

  useEffect(() => {
    if (
      Object.keys(selectedInspection).length &&
      selfInspections2?.pages?.flat().length >= FLEET_SELF_INSPECTIONS
    ) {
      const { vehicle } = selectedInspection;
      const { parts } = vehicle;

      setSteps((currSteps: any) => {
        const newSteps = currSteps;

        parts.forEach((part: any) => {
          if (
            newSteps.findIndex((step: any) => step?.part?.id === part.id) === -1
          ) {
            newSteps.push({
              title: 'Fotografías',
              content: <VehiclePart vehicle={vehicle} vehiclePart={part} />,
              part,
            });
          }
        });

        if (
          newSteps.findIndex((step: any) => step.title === 'Resumen') === -1
        ) {
          newSteps.push({
            title: 'Resumen',
            content: <SelfInspectionSummary />,
          });
        }

        return newSteps;
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInspection, selfInspections2?.pages, setSteps]);

  useEffect(() => {
    setStepperTitle(steps[step].title);
    setStep(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>
      <StepperSubHeader
        goBack={goBack}
        step={step}
        closeAction={reset}
        totalSteps={steps.length}
      ></StepperSubHeader>
      <Grid
        container
        justify={step === 3 ? 'flex-end' : 'center'}
        style={{ height: 'calc(100% - 4px)' }}
      >
        <Grid
          item
          xs={11}
          md={step === 3 ? 11 : 9}
          lg={step === 3 ? 11 : 8}
          xl={step === 3 ? 11 : 7}
        >
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              {steps[step].content}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default SelfInspectionWrapped;
